import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const CrossIcon = React.memo(function CrossIcon(props: TCrossIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Cross" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.7061 6.70694C17.0965 6.31632 17.0964 5.68316 16.7057 5.29273C16.3151 4.90229 15.682 4.90244 15.2915 5.29306L10.9994 9.58723L6.70728 5.29306C6.31685 4.90244 5.68369 4.90229 5.29307 5.29273C4.90245 5.68316 4.9023 6.31632 5.29273 6.70694L9.58553 11.0018L5.29273 15.2966C4.90229 15.6872 4.90244 16.3204 5.29306 16.7108C5.68368 17.1013 6.31684 17.1011 6.70727 16.7105L10.9994 12.4163L15.2915 16.7105C15.682 17.1011 16.3151 17.1013 16.7058 16.7108C17.0964 16.3204 17.0965 15.6872 16.7061 15.2966L12.4133 11.0018L16.7061 6.70694Z"
            />
        </IconBase>
    );
});

export default CrossIcon;

// #region Types

export type TCrossIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <CrossIcon /> : { ...IconBaseExample, render: CrossIcon };

// #endregion
